import { API_ROUTES } from "../../configuration/RoutesApi"
import { useError } from "../../context/useErrorContext"
import { AdminRuntimeStats } from "../../Objects/AdminDashboard/AdminRuntimeStats"
import { ERequestType } from "../../Enum/ERequestType"
import { GetRequest } from "../../services/ApiClientService"

export const useGetAdminRuntimeStats = () => {
  const { setError } = useError()

  const handleGetAdminRuntimeStats = async (onSuccess: (data: AdminRuntimeStats) => void, silent: boolean = false) => {
    try {
      const response = await GetRequest<AdminRuntimeStats>(API_ROUTES.ADMIN_DASHBOARD.GET_RUNTIME, ERequestType.Admin)

      if (!response.success) {
        throw new Error(response.message)
      }

      onSuccess(new AdminRuntimeStats(response.data ?? {}))
    } catch (e: unknown) {
      if (!silent) {
        const message = e instanceof Error ? e.message : "Erro ao carregar estatísticas operacionais."
        setError("Monitoramento de servidor", message)
      }
    }
  }

  return {
    handleGetAdminRuntimeStats,
  }
}
